import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { SearchResultsModel } from '../models/search-results-model';
import { AdamsDocModel } from '../models/adams-doc-model';
import { ResultSelectionService } from './result-selection.service';

@Injectable({
  providedIn: 'root'
})
// Reports Download Service
export class ReportsDownloadService {

  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  EXCEL_EXTENSION = '.xlsx';

  downloadedItems: SearchResultsModel[] = [];

  constructor(private selectedSvc: ResultSelectionService) { }

  clearItems() {
    this.downloadedItems = [];
  }

  escapeValues(text: string): string {
    if (text.includes(',') || text.includes('"')) {
      //Escape the double quotes first then the commas
      text = text.replace(/"/g, '""');
    }

    text = '"' + text + '"';
    return text;
  }

  csvDownload(headers: any, data: any) {
    if (!data || !data.length) {
      return;
    }

    const separator = ',';
    const csvContent: any = headers.join(separator) + '\n' +
      data.map((rowData: any) => {
        return headers.map((headKey: any) => {
          return rowData[headKey] ===
            null ||
            rowData[headKey] ===
            undefined ? ''
            : this.escapeValues(rowData[headKey]); //Escape the data if there are commas
        }).join(separator);
      }).join('\n');

    this.exportFile(csvContent, 'text/csv');
  }

  jsonDownload(data: AdamsDocModel[]) {
    if (!data || !data.length) {
      return;
    }
    // console.log("writing JSON");
    this.exportJsonFile(JSON.stringify(data));
  }

  private exportJsonFile(data: any) {
    const blob = new Blob([data], { type: 'application/json' });
    let ct = Math.floor(new Date().getTime() / 1000);
    FileSaver.saveAs(blob, 'Adams-JSON-Content-' + ct);
  }

  exportFile(data: any, fileType: string) {
    const blob = new Blob([data], { type: fileType });
    let ct = Math.floor(new Date().getTime() / 1000);
    FileSaver.saveAs(blob, 'Adams-SearchResults-' + ct);
  }

  flattenArrayStr(docs: any[]): any[] {
    // List of the columns that are StrCol
    const propsToFlatten = ['AuthorName', 'AddresseeName', 'AuthorAffiliation', 'AddresseeAffiliation',
      'CaseReferenceNumber', 'DocumentReportNumber', 'DocumentType',
      'DocketNumber', 'LicenseNumber', 'Keyword', 'FoldersFiledIn','PackagesFiledIn', 'CUIDocumentSensitivity', 'PackageNumber'];

    const newData = docs.map(item => {
      return propsToFlatten.reduce((acc, curr) => {
        if (item.hasOwnProperty(curr) && Array.isArray(item[curr])) {
          acc[curr] = item[curr].join(', ');
        }

        return acc;
      }, { ...item });
    });

    return newData;
  }

  exportAsExcelFile(headers: any[], json: any[]): void {
    let docResults = this.fitlerDocsByHeaders(headers, json);
    //TODO: filter out only the headers we want.

    //Flatten the strCollection fields
    let finalDocs = this.flattenArrayStr(docResults);

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(finalDocs);
    // const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(docResults);

    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, "Adams-SearchResults-");
  }

  private fitlerDocsByHeaders(headers: any[], docs: any[]): any[] {
    const filteredDocs: any[] = [];

    for (const doc of docs) {
      const filteredDoc: any = {};

      for (const header of headers) {
        if (doc.hasOwnProperty(header)) {
          filteredDoc[header] = doc[header];
        }
      }
      filteredDocs.push(filteredDoc);
    }

    return filteredDocs;
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + this.EXCEL_EXTENSION);
  }
}
